import * as firebase from 'firebase';


var config = {
    apiKey: "AIzaSyCv290017WhuHkvT_GSkzfkfN2s13IXvQA",
    authDomain: "summit-group-building.firebaseapp.com",
    databaseURL: "https://summit-group-building.firebaseio.com",
    projectId: "summit-group-building",
    storageBucket: "summit-group-building.appspot.com",
    messagingSenderId: "686483451626",
    appId: "1:686483451626:web:221215b6fb4ecb6b18f193"
  };
  firebase.initializeApp(config);
  

  export default firebase
    
  
  